import { css } from "lit";

export default css`
  :host([size="xs"]) {
    font-size: var(--wa-font-size-xs);
  }

  :host([size="s"]),
  :host([size="small"]) {
    font-size: var(--wa-font-size-s);
  }

  :host([size="m"]),
  :host([size="medium"]) {
    font-size: var(--wa-font-size-m);
  }

  :host([size="l"]),
  :host([size="large"]) {
    font-size: var(--wa-font-size-l);
  }

  :host([size="xl"]) {
    font-size: var(--wa-font-size-xl);
  }
`;
